import React from "react";
import { useTranslation } from 'react-i18next';

export default function UnitDetailsFormatter({cell, row}) {
  const { t } = useTranslation();
  return(
    <>
      {
        row.dual && 
        <span>
          {`[ ${t('projects')} ${row.NameProject} ] - `}
        </span>
      }
      {
        (row.GroupProfile && row.GroupProfile !== "") &&
        <>
          <span>
            {row.GroupProfile}
          </span>
          <strong className="h6 text-primary">
            {" / "}
          </strong>
        </>
      }
      {
        (row.Fitting && row.Fitting !== "") &&
        <>
          <span>
            {row.Fitting}
          </span>
          <strong className="h6 text-primary">
            {" / "}
          </strong>
        </>
      }
      {
        (row.Glass && row.Glass !== "") &&
        <span>
          {row.Glass}
        </span>
      }
    </>
  );
}